/**
 * Ordena pendentes: essenciais primeiro, depois por createdAt desc.
 *
 * @param {Array<{ isEssential?: boolean, createdAt?: string|null }>} [notifications]
 * @returns {Array}
 */
export function sortPendingNotifications(notifications) {
  if (!Array.isArray(notifications)) return [];

  return [...notifications].sort((a, b) => {
    const aEssential = Boolean(a?.isEssential);
    const bEssential = Boolean(b?.isEssential);
    if (aEssential !== bEssential) {
      return aEssential ? -1 : 1;
    }

    const aTime = Date.parse(a?.createdAt || "") || 0;
    const bTime = Date.parse(b?.createdAt || "") || 0;
    return bTime - aTime;
  });
}
